import { SvgIcon } from '@mui/material';

interface MicrophoneIconProps {
  muted?: boolean;
  /**
   * Hex color for the icon; Default is #F7F7F7
   */
  color?: string;
}

function MicrophoneIcon({ muted, color = '#F7F7F7' }: Readonly<MicrophoneIconProps>) {
  return (
    <SvgIcon>
      {muted ? (
        <svg
          width='25'
          height='24'
          viewBox='0 0 25 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <g clipPath='url(#clip0_10473_1167)'>
            <path
              d='M12.5 18.75V21.75'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M15.0228 14.775C14.333 15.4034 13.4331 15.7511 12.5 15.75C11.5054 15.75 10.5516 15.3549 9.84835 14.6517C9.14509 13.9484 8.75 12.9946 8.75 12V7.875'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M9.3125 4.03125C9.64801 3.48735 10.1169 3.03821 10.6748 2.72646C11.2327 2.41471 11.8609 2.2507 12.5 2.25C13.4946 2.25 14.4484 2.64509 15.1517 3.34835C15.8549 4.05161 16.25 5.00544 16.25 6V11.6653'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M17.0403 16.995C16.0727 17.8746 14.8704 18.4542 13.5795 18.6633C12.2887 18.8724 10.9649 18.7021 9.76903 18.1731C8.57317 17.644 7.55673 16.779 6.84325 15.6831C6.12976 14.5872 5.74996 13.3077 5.75 12'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M19.2504 12C19.2514 12.8397 19.0953 13.6721 18.79 14.4544'
              stroke={color}
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
            <path
              d='M5 3.75L20 20.25'
              stroke='#F83B3B'
              strokeWidth='1.5'
              strokeLinecap='round'
              strokeLinejoin='round'
            />
          </g>
          <defs>
            <clipPath id='clip0_10473_1167'>
              <rect
                width='24'
                height='24'
                fill='white'
                transform='translate(0.5)'
              />
            </clipPath>
          </defs>
        </svg>
      ) : (
        <svg
          width='25'
          height='24'
          viewBox='0 0 25 24'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            d='M12.5 16.5C13.6931 16.4988 14.837 16.0243 15.6806 15.1806C16.5243 14.337 16.9988 13.1931 17 12V6C17 4.80653 16.5259 3.66193 15.682 2.81802C14.8381 1.97411 13.6935 1.5 12.5 1.5C11.3065 1.5 10.1619 1.97411 9.31802 2.81802C8.47411 3.66193 8 4.80653 8 6V12C8.00124 13.1931 8.47575 14.337 9.31939 15.1806C10.163 16.0243 11.3069 16.4988 12.5 16.5ZM9.5 6C9.5 5.20435 9.81607 4.44129 10.3787 3.87868C10.9413 3.31607 11.7044 3 12.5 3C13.2956 3 14.0587 3.31607 14.6213 3.87868C15.1839 4.44129 15.5 5.20435 15.5 6V12C15.5 12.7956 15.1839 13.5587 14.6213 14.1213C14.0587 14.6839 13.2956 15 12.5 15C11.7044 15 10.9413 14.6839 10.3787 14.1213C9.81607 13.5587 9.5 12.7956 9.5 12V6ZM13.25 19.4625V21.75C13.25 21.9489 13.171 22.1397 13.0303 22.2803C12.8897 22.421 12.6989 22.5 12.5 22.5C12.3011 22.5 12.1103 22.421 11.9697 22.2803C11.829 22.1397 11.75 21.9489 11.75 21.75V19.4625C9.90091 19.2743 8.18728 18.4072 6.94048 17.0288C5.69368 15.6504 5.00228 13.8586 5 12C5 11.8011 5.07902 11.6103 5.21967 11.4697C5.36032 11.329 5.55109 11.25 5.75 11.25C5.94891 11.25 6.13968 11.329 6.28033 11.4697C6.42098 11.6103 6.5 11.8011 6.5 12C6.5 13.5913 7.13214 15.1174 8.25736 16.2426C9.38258 17.3679 10.9087 18 12.5 18C14.0913 18 15.6174 17.3679 16.7426 16.2426C17.8679 15.1174 18.5 13.5913 18.5 12C18.5 11.8011 18.579 11.6103 18.7197 11.4697C18.8603 11.329 19.0511 11.25 19.25 11.25C19.4489 11.25 19.6397 11.329 19.7803 11.4697C19.921 11.6103 20 11.8011 20 12C19.9977 13.8586 19.3063 15.6504 18.0595 17.0288C16.8127 18.4072 15.0991 19.2743 13.25 19.4625Z'
            fill={color}
          />
        </svg>
      )}
    </SvgIcon>
  );
}
export default MicrophoneIcon;
